import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from './analytics'

// Client-side navigation never reloads the page, so without this only the
// very first load would be counted. Reports every route change as a page view.
const PageViewTracker = () => {
  const { pathname, search } = useLocation()

  useEffect(() => {
    trackPageView(pathname + search)
  }, [pathname, search])

  return null
}

export default PageViewTracker
